import React from 'react'
import gsap, { Power1, Power4, TimelineMax } from 'gsap'
import { withStyles } from '@material-ui/core/styles/index'

const styles = theme => ({
    root: {
        height: 0,
        //paddingBottom: '55%',
        paddingBottom: 'calc(100% + 16px)'
    },
    rootSmall: {
        paddingBottom: '50%'
    },
    sector: {
        fontWeight: 800
    },
    sectorAccent: {
        background: ''
    }
})

function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min
}

const defaultSectors = [
    {
        id: 1,
        label: '1',
        priceStr: 'Pyöräytä uudestaan!',
        priceValue: 0,
        startOffset: '85%',
        fontSize: 18,
        fontWeight: 800,
        background: 'white',
        start: 90,
        end: 120,
        style: {
            background: 'white',
            fontSize: 18,
            fontWeight: 800,
            color: 'black'
        }
    },
    {
        id: 2,
        label: '2',
        priceStr: 'Sait pottiin jo {priceValue} €! Pyöräytä uudestaan!',
        priceValue: 250,
        startOffset: '85%',
        fontSize: 18,
        fontWeight: 800,
        background: '#badfff',
        start: 60,
        end: 90,
        style: {
            background: 'white',
            fontSize: 18,
            fontWeight: 800,
            color: 'black'
        }
    },
    {
        id: 3,
        label: '3',
        priceStr: 'Pyöräytä uudestaan!',
        priceValue: 0,
        startOffset: '85%',
        fontSize: 18,
        fontWeight: 800,
        background: 'white',
        start: 30,
        end: 60,
        style: {
            background: 'white',
            fontSize: 18,
            fontWeight: 800,
            color: 'black'
        }
    },
    {
        id: 4,
        label: '4',
        priceStr: 'Ei valitettavasti voittoa tällä kertaa. Kokeile uudestaan!',
        priceValue: 0,
        startOffset: '85%',
        fontSize: 18,
        fontWeight: 800,
        background: '#badfff',
        start: 0,
        end: 30,
        style: {
            background: 'white',
            fontSize: 18,
            fontWeight: 800,
            color: 'black'
        }
    },
    {
        id: 5,
        label: '5',
        priceStr: 'Onnea! Osallistu 1000€ PÄÄVOITON arvontaan! 🎉',
        priceValue: 1000,
        startOffset: '25%',
        fontSize: 18,
        fontWeight: 800,
        background: '#ff6600',
        color: 'white',
        start: 330,
        end: 360,
        style: {
            background: 'white',
            fontSize: 18,
            fontWeight: 800,
            color: 'black'
        }
    },
    {
        id: 6,
        label: '6',
        priceStr: 'Ei valitettavasti voittoa tällä kertaa. Kokeile uudestaan!',
        priceValue: 0,
        startOffset: '85%',
        fontSize: 18,
        fontWeight: 800,
        background: '#badfff',
        start: 300,
        end: 330,
        style: {
            background: 'white',
            fontSize: 18,
            fontWeight: 800,
            color: 'black'
        }
    },
    {
        id: 7,
        label: '7',
        priceStr: 'Pyöräytä uudestaan!',
        priceValue: 0,
        startOffset: '85%',
        fontSize: 18,
        fontWeight: 800,
        background: 'white',
        start: 270,
        end: 300,
        style: {
            background: 'white',
            fontSize: 18,
            fontWeight: 800,
            color: 'black'
        }
    },
    {
        id: 8,
        label: '8',
        priceStr: 'Sait pottiin jo {priceValue} €! Pyöräytä uudestaan!',
        priceValue: 250,
        startOffset: '85%',
        fontSize: 18,
        fontWeight: 800,
        background: '#badfff',
        start: 240,
        end: 270,
        style: {
            background: 'white',
            fontSize: 18,
            fontWeight: 800,
            color: 'black'
        }
    },
    {
        id: 9,
        label: '9',
        priceStr: 'Pyöräytä uudestaan!',
        priceValue: 0,
        startOffset: '85%',
        fontSize: 18,
        fontWeight: 800,
        background: 'white',
        start: 210,
        end: 240,
        style: {
            background: 'white',
            fontSize: 18,
            fontWeight: 800,
            color: 'black'
        }
    },
    {
        id: 10,
        label: '10',
        priceStr: 'Sait pottiin jo {priceValue} €! Pyöräytä uudestaan!',
        priceValue: 500,
        startOffset: '85%',
        fontSize: 18,
        fontWeight: 800,
        background: '#badfff',
        start: 180,
        end: 210,
        style: {
            background: 'white',
            fontSize: 18,
            fontWeight: 800,
            color: 'black'
        }
    },
    {
        id: 11,
        label: '11',
        priceStr: 'Ei valitettavasti voittoa tällä kertaa. Kokeile uudestaan!',
        priceValue: 0,
        startOffset: '85%',
        fontSize: 18,
        fontWeight: 800,
        background: 'white',
        start: 150,
        end: 180,
        style: {
            background: 'white',
            fontSize: 18,
            fontWeight: 800,
            color: 'black'
        }
    },
    {
        id: 12,
        label: '12',
        priceStr: 'Sait pottiin jo {priceValue} €! Pyöräytä uudestaan!',
        priceValue: 500,
        startOffset: '85%',
        fontSize: 18,
        fontWeight: 800,
        background: '#badfff',
        start: 120,
        end: 150,
        style: {
            background: 'white',
            fontSize: 18,
            fontWeight: 800,
            color: 'black'
        }
    }
]

const backgroundPrimaryPrice = '#652D33'
const backgroundSecondaryPrice = '#CAB4A6'
const backgroundNoPrize = '#badfff'
const backgroundSpinAgain = 'white'
const textColorPrimaryPrice = 'white'
const textColorSecondaryPrice = 'black'

class LuckyWheel extends React.Component {
    constructor(props) {
        super(props)
        this.wheel = React.createRef()
        this.active = React.createRef()
    }

    state = {
        currentDeg: 0,
        sectors: []
    }

    componentDidMount() {
        //this.spin()
        //this.setState({ sectors: defaultSectors })
        this.mergeSectors()
        console.log(this.state)
    }

    getStyle = type => {
        switch (type) {
            case 'primary_price':
                return {
                    fontSize: 24,
                    fontWeight: 700,
                    color: textColorPrimaryPrice,
                    background: backgroundPrimaryPrice
                }
            case 'secondary_price':
                return {
                    fontSize: 20,
                    fontWeight: 600,
                    color: textColorSecondaryPrice,
                    background: backgroundSecondaryPrice
                }
            case 'spin_again':
                return {
                    fontSize: 18,
                    fontWeight: 500,
                    color: textColorSecondaryPrice,
                    background: backgroundSpinAgain
                }
            case 'no_prize':
                return {
                    fontSize: 16,
                    fontWeight: 400,
                    color: textColorSecondaryPrice,
                    background: backgroundNoPrize
                }
        }
    }

    mergeSectors = () => {
        let sectors = defaultSectors
        let wheelSectors = this.props.sectors
        for (let i = 0; i < sectors.length; i++) {
            //console.log(sectors[i])
            sectors[i].action = wheelSectors[i].action
            sectors[i].label = wheelSectors[i].label
            sectors[i].style = this.getStyle(wheelSectors[i].action)
            //sectors[i].fontSize = 20
            //console.log(sectors[i])
            /* sectors[i].priceStr = wheelSectors[i].priceStr
            sectors[i].priceValue = wheelSectors[i].priceValue*/
        }
        this.setState({ sectors: sectors })
    }

    spin = () => {
        var wheel = this.wheel.current,
            active = this.active.current,
            currentRotation,
            lastRotation,
            tolerance

        const determinedSector = this.props.determinedSector
        const sector = this.state.sectors.find(sector => sector.action === determinedSector.action)

        // Calculate the midpoint degree of the target sector
        let targetDegree = (sector.start + sector.end) / 2

        // Adjust targetDegree based on currentDegree
        // If currentDegree is more than targetDegree, we need to add 360 to targetDegree
        if (this.state.currentDeg > targetDegree) {
            targetDegree += 360
        }

        let extraSpins = Math.floor(Math.random() * 2) + 2
        // Calculate the total spin degree
        let totalSpinDegree = targetDegree + 360 * extraSpins
        console.log(totalSpinDegree)

        //var deg = this.state.currentDeg + getRandomInt(720, 2400)
        var deg = totalSpinDegree
        this.setState({ currentDeg: deg })

        var repeatN = Math.floor(deg / 360)

        var indicator = new TimelineMax({})
        var spinWheel = new TimelineMax({ onComplete: this.handleSpinComplete })
        indicator
            .to(active, 0.13, { rotation: -10, transformOrigin: '65% 36%', ease: Power1.easeOut })
            .to(active, 0.13, { rotation: 3, backgroundColor: 'red', transformOrigin: '65% 36%', ease: Power1.easeOut })

        indicator.timeScale(1).seek(1)
        spinWheel.timeScale(0.5).seek(0.5)

        spinWheel
            .to(wheel, 5, {
                rotation: deg,
                transformOrigin: 'center center',
                ease: Power4.easeOut,
                onUpdate: function() {
                    currentRotation = Math.round(gsap.getProperty(this._targets[0], 'rotation'))
                    tolerance = currentRotation - lastRotation
                    //tolerance = spinWheel.progress() <= 0.4 ? 10 : 0;

                    //console.log(spinWheel.progress(), Math.round(currentRotation) % (360 / 12), tolerance, Math.round(currentRotation) % (360 / 12) <= tolerance)
                    if (Math.round(currentRotation) % (360 / 12) <= tolerance) {
                        if (indicator.progress() > 0.3 || indicator.progress() === 0) {
                            indicator.play(0)
                        }
                    }
                    lastRotation = currentRotation
                }
            })
            .add('end')
    }

    handleSpinComplete = () => {
        /*const startDegrees = (360 / 12) * 4
        const degrees = Math.round(this.state.currentDeg - startDegrees) % 360
        const sector = 11 - Math.floor(degrees / (360 / 12))
        if (this.props.onComplete) {
            this.props.onComplete(defaultSectors?.[sector] ?? null)
        }*/
        if (this.props.onComplete) {
            this.props.onComplete(this.props.determinedSector)
        }
    }

    render() {
        const { classes, size } = this.props

        const textStyle = {}

        return (
            <>
                <div className={classes.root + ' ' + (size === 'small' ? classes.rootSmall : '')}>
                    <div className="row">
                        <div className="luckywheel">
                            <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 729.1 729.1">
                                <g ref={this.wheel}>
                                    <path
                                        id="szele"
                                        d="M509.6,46.5C333.8-32.8,127.1,45.4,47.9,221.2A349.1,349.1,0,0,0,149.6,638.6C301,758,520.6,732.1,640,580.7a348.9,348.9,0,0,0,.9-430.9,357,357,0,0,0-27.6-31.3A348.6,348.6,0,0,0,509.6,46.5Z"
                                        transform="translate(0)"
                                        fill="#fff"
                                    />
                                    <path
                                        d="M500.1,67.5C350-.3,172.9,54.6,87.3,195.3,9.1,323.4,28.8,488.4,134.8,594.7a340.6,340.6,0,0,0,29.1,25.9c141.2,111.7,346.2,87.8,457.9-53.4a326.1,326.1,0,0,0,1-403.3A376.4,376.4,0,0,0,597,134.7,326.5,326.5,0,0,0,500.1,67.5Z"
                                        transform="translate(0)"
                                        fill="#3f3c42"
                                    />
                                    <g>
                                        <g>
                                            <path
                                                id="p1"
                                                d="M201.7,83.1A323.1,323.1,0,0,0,82.8,202.9L365.9,364.7Z"
                                                transform="translate(0)"
                                                fill={this.state.sectors[0]?.style.background}
                                            />
                                            <text transform={'rotate(-12) translate(-80 70)'} style={textStyle}>
                                                <textPath
                                                    xlinkHref="#p1"
                                                    textAnchor="middle"
                                                    startOffset={this.state.sectors[0]?.startOffset}
                                                    fontSize={this.state.sectors[0]?.style.fontSize}
                                                    fontWeight={this.state.sectors[0]?.style.fontWeight}
                                                    fill={this.state.sectors[0]?.style.color}
                                                >
                                                    {this.state.sectors[0]?.label}
                                                </textPath>
                                            </text>
                                            <path
                                                id="p2"
                                                d="M82.8,202.9a326.7,326.7,0,0,0-43,163.2l326.1-1.4Z"
                                                transform="translate(0)"
                                                fill={defaultSectors[11]?.style.background}
                                            />
                                            <text transform={'rotate(-12) translate(-80 70)'} style={textStyle}>
                                                <textPath
                                                    xlinkHref="#p2"
                                                    textAnchor="middle"
                                                    startOffset={defaultSectors[11]?.startOffset}
                                                    fontSize={defaultSectors[11]?.style.fontSize}
                                                    fontWeight={defaultSectors[11]?.style.fontWeight}
                                                    fill={defaultSectors[11]?.style.color}
                                                >
                                                    {defaultSectors[11]?.label}
                                                </textPath>
                                            </text>
                                            <path
                                                id="p3"
                                                d="M364.5,38.6A324.8,324.8,0,0,0,201.7,83.1L365.9,364.7Z"
                                                transform="translate(0)"
                                                fill={defaultSectors[1]?.style.background}
                                            />
                                            <text transform={'rotate(-12) translate(-80 70)'} style={textStyle}>
                                                <textPath
                                                    xlinkHref="#p3"
                                                    textAnchor="middle"
                                                    startOffset={defaultSectors[1]?.startOffset}
                                                    fontSize={defaultSectors[1]?.style.fontSize}
                                                    fontWeight={defaultSectors[1]?.style.fontWeight}
                                                    fill={defaultSectors[1]?.style.color}
                                                >
                                                    {defaultSectors[1]?.label}
                                                </textPath>
                                            </text>
                                            <path
                                                id="p4"
                                                d="M39.8,366.1A323.8,323.8,0,0,0,84.3,528.9L365.9,364.7Z"
                                                transform="translate(0)"
                                                fill={defaultSectors[10]?.style.background}
                                            />
                                            <text transform={'rotate(-13) translate(-80 70)'} style={textStyle}>
                                                <textPath
                                                    xlinkHref="#p4"
                                                    textAnchor="middle"
                                                    startOffset={defaultSectors[10]?.startOffset}
                                                    fontSize={defaultSectors[10]?.style.fontSize}
                                                    fontWeight={defaultSectors[10]?.style.fontWeight}
                                                    fill={defaultSectors[10]?.style.color}
                                                >
                                                    {defaultSectors[10]?.label}
                                                </textPath>
                                            </text>
                                            <path
                                                id="p5"
                                                d="M647.5,200.5A323.8,323.8,0,0,0,527.7,81.6L365.9,364.7Z"
                                                transform="translate(0)"
                                                fill={defaultSectors[3]?.style.background}
                                            />
                                            <text transform={'rotate(-14) translate(-90 80)'} style={textStyle}>
                                                <textPath
                                                    xlinkHref="#p5"
                                                    textAnchor="middle"
                                                    startOffset={defaultSectors[3]?.startOffset}
                                                    fontSize={defaultSectors[3]?.style.fontSize}
                                                    fontWeight={defaultSectors[3]?.style.fontWeight}
                                                    fill={defaultSectors[3]?.style.color}
                                                >
                                                    {defaultSectors[3]?.label}
                                                </textPath>
                                            </text>
                                            <path
                                                id="p6"
                                                d="M527.7,81.6a326.7,326.7,0,0,0-163.2-43l1.4,326.1Z"
                                                transform="translate(0)"
                                                fill={defaultSectors[2]?.style.background}
                                            />
                                            <text transform={'rotate(-12) translate(-80 70)'} style={textStyle}>
                                                <textPath
                                                    xlinkHref="#p6"
                                                    textAnchor="middle"
                                                    startOffset={defaultSectors[2]?.startOffset}
                                                    fontSize={defaultSectors[2]?.style.fontSize}
                                                    fontWeight={defaultSectors[2]?.style.fontWeight}
                                                    fill={defaultSectors[2]?.style.color}
                                                >
                                                    {defaultSectors[2]?.label}
                                                </textPath>
                                            </text>
                                            <path
                                                id="p7"
                                                d="M530.1,646.3A325.3,325.3,0,0,0,649,526.5L365.9,364.7Z"
                                                transform="translate(0)"
                                                fill={defaultSectors[6]?.style.background}
                                            />
                                            <text transform={'rotate(-12) translate(-80 70)'} style={textStyle}>
                                                <textPath
                                                    xlinkHref="#p7"
                                                    textAnchor="middle"
                                                    startOffset={defaultSectors[6]?.startOffset}
                                                    fontSize={defaultSectors[6]?.style.fontSize}
                                                    fontWeight={defaultSectors[6]?.style.fontWeight}
                                                    fill={defaultSectors[6]?.style.color}
                                                >
                                                    {defaultSectors[6]?.label}
                                                </textPath>
                                            </text>
                                            <path
                                                id="p8"
                                                d="M365.9,364.7,692,363.3a324.8,324.8,0,0,0-44.5-162.8Z"
                                                transform="translate(0)"
                                                fill={defaultSectors[4]?.style.background}
                                            />
                                            <text transform={'rotate(-12) translate(-80 70)'} style={textStyle}>
                                                <textPath
                                                    xlinkHref="#p8"
                                                    textAnchor="middle"
                                                    startOffset={defaultSectors[4]?.startOffset}
                                                    fontSize={defaultSectors[4]?.style.fontSize}
                                                    fontWeight={defaultSectors[4]?.style.fontWeight}
                                                    fill={defaultSectors[4]?.style.color}
                                                >
                                                    {defaultSectors[4]?.label}
                                                </textPath>
                                            </text>
                                            <path
                                                id="p9"
                                                d="M649,526.5a326.7,326.7,0,0,0,43-163.2l-326.1,1.4Z"
                                                transform="translate(0)"
                                                fill={defaultSectors[5]?.style.background}
                                            />
                                            <text transform={'rotate(-12) translate(-80 70)'} style={textStyle}>
                                                <textPath
                                                    xlinkHref="#p9"
                                                    textAnchor="middle"
                                                    startOffset={defaultSectors[5]?.startOffset}
                                                    fontSize={defaultSectors[5]?.style.fontSize}
                                                    fontWeight={defaultSectors[5]?.style.fontWeight}
                                                    fill={defaultSectors[5]?.style.color}
                                                >
                                                    {defaultSectors[5]?.label}
                                                </textPath>
                                            </text>
                                            <path
                                                id="p10"
                                                d="M84.3,528.9A324.3,324.3,0,0,0,204,647.8L365.9,364.7Z"
                                                transform="translate(0)"
                                                fill={defaultSectors[9]?.style.background}
                                            />
                                            <text transform={'rotate(-12) translate(-80 70)'} style={textStyle}>
                                                <textPath
                                                    xlinkHref="#p10"
                                                    textAnchor="middle"
                                                    startOffset={defaultSectors[9]?.startOffset}
                                                    fontSize={defaultSectors[9]?.style.fontSize}
                                                    fontWeight={defaultSectors[9]?.style.fontWeight}
                                                    fill={defaultSectors[9]?.style.color}
                                                >
                                                    {defaultSectors[9]?.label}
                                                </textPath>
                                            </text>
                                            <path
                                                id="p11"
                                                d="M367.3,690.8a324.8,324.8,0,0,0,162.8-44.5L365.9,364.7Z"
                                                transform="translate(0)"
                                                fill={defaultSectors[7]?.style.background}
                                            />
                                            <text transform={'rotate(-12) translate(-80 70)'} style={textStyle}>
                                                <textPath
                                                    xlinkHref="#p11"
                                                    textAnchor="middle"
                                                    startOffset={defaultSectors[7]?.startOffset}
                                                    fontSize={defaultSectors[7]?.style.fontSize}
                                                    fontWeight={defaultSectors[7]?.style.fontWeight}
                                                    fill={defaultSectors[7]?.style.color}
                                                >
                                                    {defaultSectors[7]?.label}
                                                </textPath>
                                            </text>
                                            <path
                                                id="p12"
                                                d="M204,647.8a326.8,326.8,0,0,0,163.3,43l-1.4-326.1Z"
                                                transform="translate(0)"
                                                fill={defaultSectors[8]?.style.background}
                                            />
                                            <text transform={'rotate(-12) translate(-80 70)'} style={textStyle}>
                                                <textPath
                                                    xlinkHref="#p12"
                                                    textAnchor="middle"
                                                    startOffset={defaultSectors[8]?.startOffset}
                                                    fontSize={defaultSectors[8]?.style.fontSize}
                                                    fontWeight={defaultSectors[8]?.style.fontWeight}
                                                    fill={defaultSectors[8]?.style.color}
                                                >
                                                    {defaultSectors[8]?.label}
                                                </textPath>
                                            </text>
                                        </g>
                                        <g opacity="0.5">
                                            <polygon points="363.7 366 212.8 102 368 363.4 363.7 366" />
                                            <polygon points="363.5 364.6 364.6 60.6 368.4 364.6 363.5 364.6" />
                                            <polygon points="363.8 363.4 516.8 100.7 368.1 365.9 363.8 363.4" />
                                            <polygon points="364.7 362.5 628.5 211.5 367.1 366.9 364.7 362.5" />
                                            <polygon points="365.9 362.2 669.9 363.4 365.9 367.2 365.9 362.2" />
                                            <polygon points="367.1 362.5 629.8 515.6 364.6 366.8 367.1 362.5" />
                                            <polygon points="368 363.4 519 627.3 363.7 366 368 363.4" />
                                            <polygon points="368.4 364.6 367.3 668.6 363.5 364.6 368.4 364.6" />
                                            <polygon points="368.1 365.9 215.1 628.5 363.8 363.4 368.1 365.9" />
                                            <polygon points="367.1 366.9 103.3 517.8 364.7 362.5 367.1 366.9" />
                                            <polygon points="365.9 367.2 61.9 366 365.9 362.2 365.9 367.2" />
                                            <polygon points="364.6 366.8 102 213.8 367.1 362.5 364.6 366.8" />
                                        </g>
                                    </g>
                                    <g id="szele-2" opacity="0.13">
                                        <path
                                            d="M365.9,49c174.4.1,315.7,141.6,315.6,316a315.6,315.6,0,0,1-45.1,162.5A320.6,320.6,0,0,1,527.4,636a315.8,315.8,0,0,1-357.1-23.5,353.2,353.2,0,0,1-28.1-25.2c-123-123.5-122.5-323.4,1-446.3A315.3,315.3,0,0,1,347.3,49.6q9.3-.6,18.6-.6m0-12c-6.4,0-12.9.2-19.3.6C166,48.1,28.2,202.9,38.7,383.5a328.1,328.1,0,0,0,267,303.3c177.8,33.3,349-83.9,382.3-261.7S603.9,75.8,425.9,42.6A326.8,326.8,0,0,0,365.9,37Z"
                                            transform="translate(0)"
                                        />
                                    </g>
                                    <g id="kozep">
                                        <path
                                            d="M397.6,306.2a66.3,66.3,0,0,0-61.2,3.6,59.4,59.4,0,0,0-12.5,9.8,63.4,63.4,0,0,0-9.9,12.5,66,66,0,0,0-3.9,61.2A68.4,68.4,0,0,0,323.6,413c1.9,1.8,3.8,3.5,5.9,5.2a66,66,0,0,0,92.9-92.4,48.8,48.8,0,0,0-5.2-5.9A63.6,63.6,0,0,0,397.6,306.2Z"
                                            transform="translate(0)"
                                            opacity="0.18"
                                            style={{ isolation: 'isolate' }}
                                        />
                                        <path
                                            d="M393.1,304.5a66.1,66.1,0,0,0-87.5,87.1,68.4,68.4,0,0,0,13.5,19.7c1.9,1.8,3.9,3.6,5.9,5.2a66.9,66.9,0,0,0,28.8,13.1,68.5,68.5,0,0,0,31.5-1.8,65.8,65.8,0,0,0,45.5-74.9,63.3,63.3,0,0,0-12.9-28.8,74.5,74.5,0,0,0-5.2-6A66.3,66.3,0,0,0,393.1,304.5Z"
                                            transform="translate(0)"
                                            fill="#fff"
                                        />
                                        <path
                                            d="M384.4,323.7a42.9,42.9,0,0,0-21.2-3.9,43.6,43.6,0,0,0-20.5,6.3A44.9,44.9,0,0,0,324.8,383a43.9,43.9,0,0,0,9.2,13.4l4,3.6a44.4,44.4,0,0,0,19.6,8.9,43.5,43.5,0,0,0,21.5-1.2,46.1,46.1,0,0,0,18.5-11.1,45.3,45.3,0,0,0,12.6-40,44.4,44.4,0,0,0-8.9-19.6,26.4,26.4,0,0,0-3.5-4A44.2,44.2,0,0,0,384.4,323.7Z"
                                            transform="translate(0)"
                                            fill="#efefef"
                                        />
                                        <path
                                            d="M370.4,354.7a9.4,9.4,0,0,0-5.2-1,9.9,9.9,0,0,0-5,1.6,11.6,11.6,0,0,0-2.1,1.6,8.3,8.3,0,0,0-1.6,2.1,9.9,9.9,0,0,0-1.6,5,11.4,11.4,0,0,0,.9,5.2,15,15,0,0,0,2.3,3.3,3.9,3.9,0,0,0,1,.8,10.6,10.6,0,0,0,4.8,2.2,11.5,11.5,0,0,0,5.2-.3,9.9,9.9,0,0,0,4.5-2.7,10.1,10.1,0,0,0,2.8-4.5,11.8,11.8,0,0,0,.3-5.3,10.4,10.4,0,0,0-2.1-4.8l-.9-1A11.9,11.9,0,0,0,370.4,354.7Z"
                                            transform="translate(0)"
                                            fill="#666"
                                        />
                                    </g>
                                    <path
                                        d="M364.5,31h0a5.5,5.5,0,0,1-5.5-5.5V5.5A5.5,5.5,0,0,1,364.5,0h0A5.5,5.5,0,0,1,370,5.5v20A5.5,5.5,0,0,1,364.5,31ZM370,723.6v-20a5.5,5.5,0,0,0-5.5-5.5h0a5.5,5.5,0,0,0-5.5,5.5v20a5.5,5.5,0,0,0,5.5,5.5h0a5.5,5.5,0,0,0,5.5-5.5ZM703.5,370.1h20.1a5.5,5.5,0,0,0,5.5-5.5h0a5.5,5.5,0,0,0-5.5-5.5H703.5a5.5,5.5,0,0,0-5.4,5.5h0A5.5,5.5,0,0,0,703.5,370.1Zm-698.1,0H25.5a5.5,5.5,0,0,0,5.5-5.5h0a5.5,5.5,0,0,0-5.5-5.5H5.4A5.5,5.5,0,0,0,0,364.6H0A5.5,5.5,0,0,0,5.4,370.1ZM538.7,73.6l10-17.3a5.5,5.5,0,0,0-2-7.5h0a5.5,5.5,0,0,0-7.5,2l-10,17.3a5.2,5.2,0,0,0,1.7,7.3l.3.2h0A5.5,5.5,0,0,0,538.7,73.6ZM189.9,678.3l10-17.3a5.5,5.5,0,0,0-2-7.5h0a5.5,5.5,0,0,0-7.5,2l-10,17.4a5.4,5.4,0,0,0,1.8,7.4h.2a5.5,5.5,0,0,0,7.5-2.1Zm9.8-610L189.6,50.9a5.5,5.5,0,0,0-7.5-2h0a5.5,5.5,0,0,0-2,7.5l10.1,17.4a5.4,5.4,0,0,0,7.4,2h0a5.5,5.5,0,0,0,2.1-7.5ZM548.9,672.7l-10-17.3a5.5,5.5,0,0,0-7.5-2h0a5.5,5.5,0,0,0-2,7.5l10,17.3a5.5,5.5,0,0,0,7.5,2h0A5.5,5.5,0,0,0,548.9,672.7ZM660.4,198.9l17.3-10.1a5.5,5.5,0,0,0,2-7.5h0a5.4,5.4,0,0,0-7.4-2h-.1l-17.4,10a5.4,5.4,0,0,0-2,7.4h.1A5.5,5.5,0,0,0,660.4,198.9ZM56.9,549.8l17.3-10.1a5.5,5.5,0,0,0,2-7.5h0a5.6,5.6,0,0,0-7.5-2L51.3,540.3a5.4,5.4,0,0,0-2,7.4h.1A5.5,5.5,0,0,0,56.9,549.8ZM73.6,190.3l-17.3-10a5.5,5.5,0,0,0-7.5,2h0a5.5,5.5,0,0,0,2,7.5l17.4,10a5.6,5.6,0,0,0,7.5-2h0a5.5,5.5,0,0,0-2.1-7.5ZM678.2,539.4l-17.3-10a5.2,5.2,0,0,0-7.3,1.7l-.2.3h0a5.6,5.6,0,0,0,2,7.5l17.3,10a5.5,5.5,0,0,0,7.5-2h0A5.5,5.5,0,0,0,678.2,539.4Z"
                                        transform="translate(0)"
                                        fill="#fff"
                                    />
                                </g>
                                <g ref={this.active}>
                                    <path
                                        d="M709.3,156.5c-11.8-18.1-36.9-22.9-55.8-10.6a41.9,41.9,0,0,0-13.8,14.6l-33.6,60.6a2.3,2.3,0,0,0,0,2.5,2.8,2.8,0,0,0,2.3,1.1l69-6.2a41.6,41.6,0,0,0,18.9-6.6C715.3,199.5,721.1,174.7,709.3,156.5Z"
                                        transform="translate(0)"
                                        fillOpacity="0.22"
                                    />
                                    <path
                                        d="M714.3,153.3a39.4,39.4,0,0,0-54.4-11.6,38.8,38.8,0,0,0-13.1,14.2l-31.5,59.2a2.3,2.3,0,0,0,.1,2.5,2.4,2.4,0,0,0,2.2,1.1l66.9-4.8a39.9,39.9,0,0,0,18.3-6.2A39.4,39.4,0,0,0,714.3,153.3Z"
                                        transform="translate(0)"
                                        fill="rgb(58, 58, 58)"
                                    />
                                    <path
                                        d="M683.6,163.4a9.8,9.8,0,0,0-4.1,1.6,8.9,8.9,0,0,0-2.7,3.4,5.4,5.4,0,0,0-.8,2.1,14.9,14.9,0,0,0-.2,2.1,10.2,10.2,0,0,0,1.2,4.2,8.4,8.4,0,0,0,3,3.2,10.1,10.1,0,0,0,3,1.3h1.1a7.8,7.8,0,0,0,4.3-.6,9.2,9.2,0,0,0,3.5-2.6,9.5,9.5,0,0,0,1.9-3.9,9.3,9.3,0,0,0-.1-4.4,9.1,9.1,0,0,0-5.8-6.1l-1.1-.3A8.6,8.6,0,0,0,683.6,163.4Z"
                                        transform="translate(0)"
                                        fill="#fff"
                                    />
                                    <path
                                        d="M684,166.5a4.7,4.7,0,0,0-2.6,1.1,5.5,5.5,0,0,0-1.8,2.2,5,5,0,0,0-.5,1.3,6.6,6.6,0,0,0-.1,1.4,5.4,5.4,0,0,0,.8,2.8,6.4,6.4,0,0,0,1.9,2.1l2,.8h.7a5.9,5.9,0,0,0,5.1-2.1,6.8,6.8,0,0,0,1.2-2.6,5.3,5.3,0,0,0-.1-2.8,4.8,4.8,0,0,0-1.4-2.5,5.1,5.1,0,0,0-2.3-1.5l-.7-.2Z"
                                        transform="translate(0)"
                                        fill="rgb(58, 58, 58)"
                                    />
                                </g>
                            </svg>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default withStyles(styles)(LuckyWheel)
